import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError } from "@/types";

type RecoveryStatusResponse = {
  has_pending_recovery: boolean;
  has_cancellable_recovery: boolean;
  recovery_transaction_id?: number;
  recovery_status?: string;
};

export const useRecoveryStatus = (
  receiverId: string | undefined,
  walletId: string | undefined,
  enabled = true,
) => {
  return useQuery<RecoveryStatusResponse, AppError>({
    queryKey: ["recovery", "status", receiverId, walletId],
    queryFn: async () => {
      return await fetchApi(
        `${API_URL}/receivers/${receiverId}/wallets/${walletId}/recovery/transactions`,
      );
    },
    enabled: enabled && !!receiverId && !!walletId,
    staleTime: Infinity,
  });
};
